<div class="absolute inset-0 z-20 flex flex-col items-center justify-center">
    <div class="relative inline-flex items-center justify-center loading-bg rounded-full"
            [ngClass]="{
            'w-[56px] h-[56px]': size === 'sm',
            'w-[72px] h-[72px]': size === 'md',
            'w-[96px] h-[96px]': size === 'lg'
            }">
        <mat-icon svgIcon="left-bracket" class="!text-white relative" [ngClass]="{
            '!h-5 !w-3': size === 'sm',
            '!h-6 !w-4': size === 'md',
            '!h-8': size === 'lg'
        }"></mat-icon>
        <div class="relative flex items-center" [ngClass]="{
            'gap-0.5': size === 'sm',
            'gap-0.75': size === 'md',
            'gap-1': size === 'lg',
        }">
        <span class="dot" [ngClass]="{'sm': size === 'sm'}"></span>
        <span class="dot delay-1" [ngClass]="{'sm': size === 'sm'}"></span>
        <span class="dot delay-2" [ngClass]="{'sm': size === 'sm'}"></span>
        <span class="dot delay-3" [ngClass]="{'sm': size === 'sm'}"></span>
        </div>
        <mat-icon svgIcon="right-bracket" class="!text-white relative" [ngClass]="{
            '!h-5 !w-3': size === 'sm',
            '!h-6 !w-4': size === 'md',
            '!h-8': size === 'lg'
        }"></mat-icon>
    </div>

    <div *ngIf="label" class="text-center w-full" [ngClass]="{
        'mt-6 title-small': size === 'sm',
        'mt-7 text-[18px] tracking-[0.15px]': size === 'md',
        'mt-10 headline-small': size === 'lg'
    }">
        <span class="text-primary">{{ label }}</span>
    </div>
</div>